// extracted by mini-css-extract-plugin
module.exports = {"loginForm":"SecretLoginPage_loginForm__1FDgi","center":"SecretLoginPage_center__3lRZF"};